"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerSvg = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../context");

var _utils = require("../utils");

var _core = require("@emotion/core");

var _excluded = ["color", "size", "strokeWidth", "showText", "loadingText"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SpinnerSvg = function SpinnerSvg(_ref) {
  var colorProp = _ref.color,
      size = _ref.size,
      strokeWidth = _ref.strokeWidth,
      showText = _ref.showText,
      loadingText = _ref.loadingText,
      outerProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var spinnerId = (0, _utils.getUniqueId)('spinner');
  var color = (0, _utils.cssProp)(selectors.color, colorProp);
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    role: showText ? undefined : 'img',
    width: size,
    height: size,
    "aria-hidden": showText,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, outerProps), !showText && loadingText && (0, _core.jsx)("title", null, loadingText), (0, _core.jsx)("defs", null, (0, _core.jsx)("mask", {
    id: "".concat(spinnerId, "-mask")
  }, (0, _core.jsx)("circle", {
    r: size / 2 - strokeWidth / 2,
    cx: size / 2,
    cy: size / 2,
    stroke: "white",
    strokeWidth: strokeWidth,
    "data-test-id": "StencilSpinnerMask"
  }))), (0, _core.jsx)("defs", null, (0, _core.jsx)("linearGradient", {
    id: "".concat(spinnerId, "-gradient")
  }, (0, _core.jsx)("stop", {
    offset: "10%",
    stopColor: color,
    stopOpacity: 0
  }), (0, _core.jsx)("stop", {
    offset: "50%",
    stopColor: color
  }))), (0, _core.jsx)("circle", {
    cx: size / 2,
    cy: strokeWidth / 2,
    r: strokeWidth / 4,
    stroke: "url(#".concat(spinnerId, "-gradient)"),
    strokeWidth: strokeWidth / 2,
    "data-test-id": "StencilSpinnerTopCircle"
  }), (0, _core.jsx)("circle", {
    r: size / 2 - strokeWidth / 2,
    cx: size / 2,
    cy: size / 2,
    stroke: color,
    strokeOpacity: 0.3,
    strokeWidth: strokeWidth,
    "data-test-id": "StencilSpinnerBottomCircle"
  }), (0, _core.jsx)("foreignObject", {
    x: 0,
    y: 0,
    width: size,
    height: size,
    mask: "url(#".concat(spinnerId, "-mask)")
  }, (0, _core.jsx)("div", {
    id: "".concat(spinnerId, "-conic-gradient"),
    style: {
      width: size,
      height: size,
      borderRadius: '50%',
      background: "\n            conic-gradient(\n              rgba(23,104,201,0),\n              rgba(23,104,201,0),\n              ".concat(color, "\n            )")
    }
  })));
};

exports.SpinnerSvg = SpinnerSvg;